// extracted by mini-css-extract-plugin
export var changeIcon = "_70-4";
export var container = "_70-0";
export var divider = "_70-7";
export var externalLinkIcon = "_70-1";
export var green = "_70-5";
export var helpCircleIcon = "_70-3";
export var iconButton = "_70-2";
export var red = "_70-6";